module.exports = __webpack_public_path__ + "static/media/CSympl_With_Music_New.c1f75d5a.mp4";